















import * as emoji from 'node-emoji'

export default {
  name: 'Facebook',

  props: {
    proofType: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: false,
      default: null,
    },
    messageContent: {
      type: String,
      required: false,
      default: null,
    },
    fbCheckin: {
      type: Object,
      required: false,
      default: null,
    },
    influencer: {
      type: Object,
      required: false,
      default: null,
    },
  },

  computed: {
    proofImage() {
      if (this.proofType === 'FACEBOOK_CHECKIN') {
        return `https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/pin-l+ec1f56(${this.fbCheckin.longitude},${this.fbCheckin.latitude})/${this.fbCheckin.longitude},${this.fbCheckin.latitude},11/300x175?logo=false&access_token=${process.env.VUE_APP_MAPBOX_API_KEY}`
      }

      return this.imageUrl
    },
    influencerName() {
      return [this.influencer.first_name, this.influencer.last_name].filter(Boolean).join(' ')
    },
    message() {
      return emoji.emojify(this.messageContent)
    },
  },
}
